export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 5_02.5562aa89.jpg";